import { useTranslator } from "@eo-locale/react";

import { Text, type TextProps } from "@/storybook-components";

const RequiredField = (props: TextProps): JSX.Element => {
  const { translate } = useTranslator();

  return (
    <Text
      my={4}
      fontSize="0.75rem"
      lineHeight="133%"
      fontWeight="normal"
      letterSpacing="0.2px"
      color="gray.600"
      {...props}
    >
      {translate("questions.requiredField")}
    </Text>
  );
};

export default RequiredField;
